import { Order, OrderDeliveryState } from '../../redux/type';
import { enumTranslator } from '../../utils';
const deliveryModelMap = new Map([
  ['COLLECTION', '集包'],
  ['NO_COLLECTION', '普通'],
  ['TRANSPORT', '接驳'],
]);
export const formatOrderList = (stop: any[], order: Order[]) => {
  const orderList: any = [];
  // stopIdList 和 deliveryNameList都是用来排序的标准，顺序固定
  const stopIdList = (stop && stop.map((item) => item.id)) || [];
  const deliveryNameList = [
    'INITIAL',
    'CANCELDROPOFF',
    'CANCEL',
    'USERCANCEL',
    'MISSDROPOFF',
    'MISSLOAD',
    'OVERDUE',
    'MISSUNLOAD',
    'DELIVERY',
    'TODROPOFF',
    'WAITING',
    'SETOUT',
    'ASSIGNED',
    'USERDROPPEDOFF',
    'COURIERFETCHED',
    'ALREADY',
    'COMPLETED',
    'UNLOAD',
  ];

  order &&
    order.forEach((orderItem: any) => {
      const { id, deliveryState, stopId, ...otherData } = orderItem;
      const obj: any = {
        id: orderItem && orderItem.id,
        name: orderItem && orderItem.name,
        contact: orderItem && orderItem.contact,
        orderId: orderItem && orderItem.orderId, // 运单号
        stopName: orderItem && orderItem.stopName, // 停靠点
        sortIndexByStopId: stopId && stopIdList.indexOf(stopId),
        deliveryState:
          orderItem &&
          orderItem.deliveryState &&
          enumTranslator('DELIVERY_STATUS_ENUM', orderItem.deliveryState),
        originDeliveryState: (orderItem && orderItem.deliveryState) || '',
        sortIndexByDeliveryStateId:
          deliveryState && deliveryNameList.indexOf(deliveryState),
        gridNoList: orderItem && orderItem.gridNoList, // 格口
        packageTotal: orderItem && orderItem.packageTotal,
        ...otherData,
        deliveryModel: enumTranslator(
          'DELIVERY_MODE_ENUM',
          orderItem.deliveryModel,
        ),
      };
      orderList.push(obj);
    });
  return orderList;
};
